import { useQuery } from '@tanstack/vue-query'
import { apiClient } from '@/apis/instances/api-client'
import { checkApiResponse } from '@/apis/instances/check-api-response'
import { ApiV2WorkholidayElFindDateParams } from '@/apis/swaggers/v2/v2-swagger'
import { QUERY_KEY } from '@/apis/swaggers/swagger-docs'
import { QueryComposableParams } from '@/types/query-options'
import { resolveMaybeGetter } from '@/util/resolve-maybe-getter'

type QueryParams = QueryComposableParams<ApiV2WorkholidayElFindDateParams, unknown>

const fetchWorkHolidaysByDate = async (params: ApiV2WorkholidayElFindDateParams) => {
  const { data } = await apiClient.v2.apiV2WorkholidayElFindDate(params);
  return checkApiResponse(data);
}

export const v2WorkHolidayDateKeys = {
  all: [QUERY_KEY.v2apiV2WorkholidayElFindDate] as const,
  list: (params: ApiV2WorkholidayElFindDateParams) => [...v2WorkHolidayDateKeys.all, params] as const,
}

/** 명령형(await) 호출용 쿼리 정의 — `queryClient.fetchQuery(v2WorkHolidayFindDateQueryOptions(params))` */
export const v2WorkHolidayFindDateQueryOptions = (params: ApiV2WorkholidayElFindDateParams) => ({
  queryKey: v2WorkHolidayDateKeys.list(params),
  queryFn: () => fetchWorkHolidaysByDate(params),
  // 날짜별 데이터 — FCM invalidation(타 사용자 변경)과 mutation invalidation(내 변경)이 커버하므로 5분 캐시
  staleTime: 5 * 60 * 1000,
  gcTime: 5 * 60 * 1000,
})

export const useV2WorkHolidayFindDateQuery = ({ params, options }: QueryParams) => {
  return useQuery(() => ({
    queryKey: v2WorkHolidayDateKeys.list(resolveMaybeGetter(params)),
    queryFn: () => fetchWorkHolidaysByDate(resolveMaybeGetter(params)),
    ...resolveMaybeGetter(options ?? {}),
  }))
}
